import { lazy, Suspense } from 'react';

import { Dialog, LoadingPanel } from '@gitbook/spine-react';

import type { TemplatePreviewProps } from './TemplatePreviewContent';

const TemplatePreviewDialogContent = lazy(() =>
    import('./TemplatePreviewContent').then((m) => ({ default: m.TemplatePreviewDialogContent }))
);

/**
 * Component to preview a template before using it.
 */
export function TemplatePreviewDialog(props: TemplatePreviewProps) {
    return (
        <TemplatePreviewDialogWrapper>
            <TemplatePreviewDialogContent {...props} />
        </TemplatePreviewDialogWrapper>
    );
}

function TemplatePreviewDialogWrapper(props: { children: React.ReactNode }) {
    return (
        <Dialog size={{ width: 1320, height: 860 }}>
            <Suspense
                fallback={
                    <div className="flex h-full w-full items-center justify-center">
                        <LoadingPanel />
                    </div>
                }
            >
                {props.children}
            </Suspense>
        </Dialog>
    );
}
